import styled from 'styled-components';
import CleanRoomIconSvg from '../../assets/hotels/amenities/clean-room1.svg';

const CleanRoomIcon = styled(CleanRoomIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || props.theme.colors.downriver.medium};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default CleanRoomIcon;
